import script from "./ProductDescriptionFormCollection.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductDescriptionFormCollection.vue?vue&type=script&setup=true&lang=ts"

import "./ProductDescriptionFormCollection.vue?vue&type=style&index=0&id=caea7114&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-caea7114"]])

export default __exports__